import './app/shared/three/three-patched';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

var link = document.createElement("link");

link.rel = "preconnect dns-prefetch";
link.href = environment.BASE_URL;

document.head.appendChild(link);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
